export default __webpack_public_path__ + "static/media/007-coconut.a9f341e1.svg";